'use client'
import Header from '@/components/common/Header'
import Sidebars from '@/components/common/Sidebar'
import ProtectedRoute from '@/middleware/ProtectedRoute'
import React, { useState } from 'react'

const layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    return (
        <>
            <ProtectedRoute>
                <div className="!flex !h-screen !bg-gray-50 !font-sans !overflow-hidden">

                    <Sidebars isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                    <div className="!flex-1 !flex !flex-col !overflow-hidden">
                        <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                        {children}
                    </div>
                </div>
            </ProtectedRoute>
        </>
    )
}

export default layout
